var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-gallery"},[_c('viewer',{staticClass:"images-list",class:( _obj = {}, _obj['box-margins'] = !!_vm.boxMargins, _obj ),attrs:{"images":_vm.images}},_vm._l((50),function(i){return _c('img',{key:i,attrs:{"src":'/static/images/gallery/photo-'+i+'.jpg',"alt":"gallery image"}})}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }